import React, { PropTypes } from 'react';
import { browserHistory } from 'react-router'
import interpolate from 'color-interpolate';
import LeafletMap from "../LeafletMap";
import { inject, observer } from "mobx-react";
import { action, observable, toJS, computed } from "mobx";
import { getCenter } from "../Map/getCenterLatLng";
import _ from 'lodash';
import Form, { FormBody, FormActions, SelectInput, DateInput } from "../Form";
import StepRangeSlider from 'react-step-range-slider';
import moment from 'moment';
import { analysis as api } from '../../actions/api';
import Spinner from '../Spinner';
import { getDisplayDate } from '../../libs/date';
import FormMultiSelectInput from "../FormMultiSelectInput";
import { generalizedRecursiveFunction } from "../../utils";

@inject('stationStore', 'tagStore', 'mapStore', 'parameterStore', 'dataSeriesStore')
@observer
class AnalysisMap extends React.Component {
	interval = null;

	@observable hidep2 = false;
	@observable playing = false;
	@observable multiStationOptions = [];

	static contextTypes = {
		notify: PropTypes.object.isRequired,
	};

	@observable selectedParameterName1 = -1;
	@observable selectedParameterName2 = -1;

	@observable p2Direction = false;

	@observable date_to = moment().format('YYYY-MM-DD');
	@observable date_from = moment().subtract(1, 'days').format('YYYY-MM-DD');
	// @observable stations = [];
	@observable markers = {};
	@observable timeRange = [];
	@observable selectedTime = 0;
	@observable isLoading = false;

	@observable p1min = 0;
	@observable p1max = 0;

	@observable p2min = 0;
	@observable changeRate = 1500;
	@observable p2max = 0;

	@observable center = {};
	@observable arrayMapObj = {};

	@observable param1Data = [];
	@observable param2Data = [];
	@observable availableParameters = [];

	@computed get selectedParameter1() {
		return this.props.parameterStore.findById(+this.selectedParameterName1);
	}

	@computed get selectedParameter2() {
		return this.props.parameterStore.findById(+this.selectedParameterName2);
	}

	generateArray = (min, max) => {
		if ((!min && min !== 0) || (!max && max !== 0)) return ({ arrayMap: [], step: max - min });
		let step = (max - min) / 100;
		if (step === 0) step = 1;
		let array = [];
		for (let i = max; i >= min; i -= step) {
			array.push(i);
		}
		return ({ arrayMap: array, step });
	};

	// @computed get markers() {
	//   return this.stations.reduce((acc, station) => {
	//     let value = station.values[moment(this.timeRange[+this.selectedTime].date).valueOf()];
	//     if (!value) return acc;
	//     acc.push(Object.assign({}, {
	//       position: [station.latitude, station.longitude],
	//       id: `station_marker-${station.id}`,
	//       // icon: `
	//       //   <svg viewBox="0 0 12 12" x="30" width="30" style="margin-left: -3px; margin-top: -5px;">
	//       //     <circle cx="6" cy="6" r="6" stroke="white" stroke-width="0.5px" fill="${this.getColorMapIndex(value)}"/>
	//       //     <text text-anchor="middle" x="6" y="8" font-size="5" fill="${value > 2 * (this.min + this.max) / 3 ? 'white' : 'black'}">${Math.floor(value)}</text>
	//       //   </svg>
	//       // `,
	//       popupBox: this.getPopupBox({ name: station.name, value })
	//     }));
	//     return acc;
	//   }, []);
	// }

	getColorMapIndex = (value, min, max) => {
		const colorMap = interpolate(['green', 'yellow', 'orange', 'red']);

		return colorMap(min === this ? 0 : (value - min) / (max - min));
	}

	componentWillMount() {
		const { parameterStore, stationStore, dataSeriesStore } = this.props;

		// tagStore.fetchItems();
		if (!stationStore.isLoading && stationStore.items.length === 0) stationStore.fetchItems();
		if (parameterStore.items.length === 0) parameterStore.fetchItems();
		if (dataSeriesStore.items.length === 0) dataSeriesStore.fetchItems();
		// if (mapStore.stations.length === 0 && !mapStore.loadingMarkers) {
		//   mapStore.fetchMapMarkers().catch(err => {
		//     console.log(err);
		//     this.context.notify.error({message: 'failed to fetch map markers'})
		//   })
		// }
		// this.onView();

		this.populateOptions();
	}

	componentDidMount() {
		console.log(this.ref)
	}

	componentWillUnmount() {
		if (this.interval) {
			clearInterval(this.interval);
		}
	}

	populateOptions = () => {
		const { stationStore } = this.props;
		if (stationStore.items.length === 0) {
			setTimeout(() => {
				this.populateOptions();
			}, 300)
		} else {
			this.multiStationOptions = stationStore.items.filter(item => !!item.latitude && !!item.longitude).map(item => ({
				id: item.id,
				name: item.name,
				label: item.name,
				value: false,
				tags: item.tags
			}));
		}
	};

	@action onChangeParameter1 = e => {
		this.selectedParameterName1 = +e.target.value;
		this.clearData();
	}
	@action onChangeParameter2 = e => {
		this.selectedParameterName2 = +e.target.value;

		if (+e.target.value <= 0 && +this.selectedParameterName1 > 0) {
			if (this.param1Data)
				this.populateParam1OnlyData(this.param1Data);
		} else {
			this.clearData();
		}
	}
	@action onChangeDateFrom = e => {
		this.date_from = e.target.value;
		this.clearData();
	}
	@action onChangeDateTo = e => {
		this.date_to = e.target.value;
		this.clearData();
	}
	@action onChangeSelectedDate = value => this.selected_date = value;
	@action onChangeSelectedTime = value => {
		if (this.interval) {
			clearInterval(this.interval);
			this.playing = false;
			this.interval = null;
		}

		this.selectedTime = value;
	}

	clearData = () => {
		this.markers = [];
		// this.stations = [];
		this.timeRange = [];
		this.selectedTime = 0;

		this.p1min = 0;
		this.p1max = 0;

		this.p2min = 0;
		this.p2max = 0;
	}

	getPopupBox = ({ name, value, p1Value }) => {
		let parameterValue = '';

		if ((this.selectedParameterName1 > 0 && this.selectedParameterName2 <= 0) || (this.hidep2 && this.selectedParameterName1 > 0)) {
			parameterValue = <span>{this.selectedParameter1.code}: {value} {this.selectedParameter1.parameter_unit_symbol}</span>;
		} else {
			if (this.selectedParameterName1 !== this.selectedParameterName2) {
				parameterValue = <span>{this.selectedParameter2.code}: {value} {this.selectedParameter2.parameter_unit_symbol}</span>;
			}
		}

		return (
			<div style={{ textAlign: "center" }}>
				<strong>{name}</strong>
				<span className="fa fa-close" style={{ position: 'absolute', right: 2, top: 2 }} onClick={() => this.props.mapStore.selectedMarker = null} />
				<br />
				{p1Value ? <span>{this.selectedParameter1.code}: {p1Value} {this.selectedParameter1.parameter_unit_symbol}</span> : ''}
				<div>{parameterValue}</div>
			</div>
		);
	};

	onMarkerClick = marker => {
		let stationId = marker.id.split('-')[1];
		browserHistory.push(`/station/${stationId}/monitoring`)
	};

	onView = async (e) => {
		e && e.preventDefault();
		this.isLoading = true;
		this.clearData();

		if ((this.selectedParameterName1 > 0 && this.selectedParameterName2 <= 0) || (this.hidep2 && this.selectedParameterName1 > 0)) {
			try {
				const res = await generalizedRecursiveFunction({
					fun: api.fetchMore,
					relevantParameters: {
						stations: this.multiStationOptions.filter(opt => opt.value).map(item => item.id),
						parameters: this.selectedParameterName1
					},
					date_from: moment(this.date_from).format('YYYY-MM-DDT00:00:00'),
					date_to: moment(this.date_to).add(1, 'days').format('YYYY-MM-DDT00:00:00'),
				});

				this.param1Data = res;

				this.populateParam1OnlyData(res);
			} catch (e) {
				console.log(e);
				this.isLoading = false;
				this.context.notify.error({ message: 'Failed to fetch' });
			}
		} else {
			try {
				const res1 = this.selectedParameterName1 > 0 ? await generalizedRecursiveFunction({
					fun: api.fetchMore,
					relevantParameters: {
						stations: this.multiStationOptions.filter(opt => opt.value).map(item => item.id),
						parameters: this.selectedParameterName1
					},
					date_from: moment(this.date_from).format('YYYY-MM-DDT00:00:00'),
					date_to: moment(this.date_to).add(1, 'days').format('YYYY-MM-DDT00:00:00'),
				}) : null;

				this.param1Data = res1;

				const res2 = await generalizedRecursiveFunction({
					fun: api.fetchMore,
					relevantParameters: {
						stations: this.multiStationOptions.filter(opt => opt.value).map(item => item.id),
						parameters: this.selectedParameterName2,
					},
					date_from: moment(this.date_from).format('YYYY-MM-DDT00:00:00'),
					date_to: moment(this.date_to).add(1, 'days').format('YYYY-MM-DDT00:00:00'),
				});

				this.param2Data = res2;

				this.populateData(res1, res2);
			} catch (e) {
				console.log(e);
				this.isLoading = false;
				this.context.notify.error({ message: 'Failed to fetch' });
			}
		}
	}

	populateData = (res1, res2) => {
		// let res = mockData;
		let timeRange = {}, p1min = 0, p1max = 0, p2min = 0, p2max = 0, markers = {};
		let totalData = 0;

		res2.forEach(station => {
			const correspondingP1 = res1 ? res1.find(i => +i.id === +station.id) : null;

			if (!!station.parameters && !!station.parameters[0] && !!station.parameters[0].data) {
				let values = {};

				totalData += station.parameters[0].data.length;
				station.parameters[0].data.forEach(({ time, value }) => {
					const correspondingP1Param = correspondingP1 && correspondingP1.parameters && correspondingP1.parameters[0] && correspondingP1.parameters[0].data ? correspondingP1.parameters[0].data.find(d => d.time === time) : null;

					// let date = moment(datetime).format('YYYY-MM-DDTHH:mm:ss');
					if (value < p2min) p2min = value;
					if (value > p2max) p2max = value;

					if (correspondingP1Param) {
						if (correspondingP1Param.value < p1min) p1min = correspondingP1Param.value;
						if (correspondingP1Param.value > p1max) p1max = correspondingP1Param.value;
					}

					let date = moment(time).seconds(0).valueOf();

					if (!timeRange[date]) timeRange = Object.assign(timeRange, { [date]: time });
					values = Object.assign(values, { [date]: !!value || +value === 0 ? _.round(value, 2) : '' })


					// for markers
					value = !!value || +value === 0 ? _.round(value, 2) : ''
					if (value !== '' && (correspondingP1Param || this.selectedParameterName1 <= 0)) {
						let marker = {
							name: station.name,
							position: [station.latitude, station.longitude],
							id: `station_marker-${station.id}`,
							station_id: station.id,
							smallerIcon: `
                  <svg viewBox="0 0 10 10" x="5" width="10" style="margin-left: -1px;margin-top: -2px;">
                    <circle cx="5" cy="5" r="4" stroke="white" stroke-width="0.5px" fill="white" />
                  </svg>`,
							latitude: station.latitude,
							longitude: station.longitude,
							value,
							p1Value: correspondingP1Param ? correspondingP1Param.value : null,
							// popupBox: this.getPopupBox({
							//   name: station.name,
							//   value,
							//   p1Value: correspondingP1Param ? correspondingP1Param.value : null
							// }),
							icon: `
                  <svg viewBox="0 0 12 12" x="30" width="30" style="margin-left: -3px; margin-top: -5px;">
                    <circle cx="6" cy="6" r="6" stroke="white" stroke-width="0.5px" fill="white"/>
                    <text text-anchor="middle" x="6" y="8" font-size="5" fill="black">${Math.floor(value)}</text>
                  </svg>
                `
						}

						if (!markers[date]) markers = Object.assign(markers, { [date]: [marker] })
						else markers[date].push(marker);
					}

				});

				// // let observationGroupedByDate = _.groupBy(station.parameters[0].data, item => moment(item.time).format('YYYY-MM-DD'));
				// // this.dateRange.forEach(({value}) => {
				// //   let date = moment().dayOfYear(value).format('YYYY-MM-DD');
				// //   values = Object.assign(values, {[date]: observationGroupedByDate[date] ? _.round((this.selectedParameter.property === 'Accumulative' ? _.sum : _.mean)(observationGroupedByDate[date].map(item => item.value)), 2) : ''})
				// // });

				// stations.push({
				//   id: station.id,
				//   name: station.name,
				//   latitude: station.latitude,
				//   longitude: station.longitude,
				//   values
				// });
			}
		});

		// console.log(markers[1597688750000].find(item => item.id == 'station_marker-989'))
		this.p1min = p1min;
		this.p1max = p1max;

		this.p2min = p2min;
		this.p2max = p2max;

		if (this.selectedParameterName1 > 0)
			this.arrayMapObj = this.generateArray(p1min, p1max);
		else
			this.arrayMapObj = this.generateArray(p2min, p2max);

		this.timeRange = Object.keys(timeRange).sort((a, b) => +a < +b ? -1 : 1).map((key, index) => ({
			value: index,
			epoch: key,
			date: timeRange[key]
		}));

		if (this.timeRange && this.timeRange[0] && this.timeRange[0].date) {
			// this.stations = stations;
			this.center = getCenter(markers[moment(this.timeRange[0].date).valueOf()])
		}

		this.markers = markers;
		this.isLoading = false;
	}

	populateParam1OnlyData = (res) => {
		let timeRange = {}, p1min = 0, p1max = 0, p2min = 0, p2max = 0, markers = {};
		let totalData = 0;

		res.forEach(station => {
			if (!!station.parameters && !!station.parameters[0] && !!station.parameters[0].data) {
				let values = {};

				totalData += station.parameters[0].data.length;
				station.parameters[0].data.forEach(({ time, value }) => {
					// let date = moment(datetime).format('YYYY-MM-DDTHH:mm:ss');
					if (value < p1min) p1min = value;
					if (value > p1max) p1max = value;

					let date = moment(time).seconds(0).valueOf();

					if (!timeRange[date]) timeRange = Object.assign(timeRange, { [date]: time });
					values = Object.assign(values, { [date]: !!value || +value === 0 ? _.round(value, 2) : '' })


					// for markers
					value = !!value || +value === 0 ? _.round(value, 2) : ''
					if (value !== '') {
						let marker = {
							name: station.name,
							position: [station.latitude, station.longitude],
							id: `station_marker-${station.id}`,
							station_id: station.id,
							smallerIcon: `
                  <svg viewBox="0 0 10 10" x="5" width="10" style="margin-left: -1px;margin-top: -2px;">
                    <circle cx="5" cy="5" r="4" stroke="white" stroke-width="0.5px" fill="white" />
                  </svg>`,
							latitude: station.latitude,
							longitude: station.longitude,
							value,
							// popupBox: this.getPopupBox({
							//   name: station.name,
							//   value,
							// }),
							icon: `
                  <svg viewBox="0 0 12 12" x="30" width="30" style="margin-left: -3px; margin-top: -5px;">
                    <circle cx="6" cy="6" r="6" stroke="white" stroke-width="0.5px" fill="white"/>
                    <text text-anchor="middle" x="6" y="8" font-size="5" fill="black">${Math.floor(value)}</text>
                  </svg>
                `
						}

						if (!markers[date]) markers = Object.assign(markers, { [date]: [marker] })
						else markers[date].push(marker);
					}

				});

				// // let observationGroupedByDate = _.groupBy(station.parameters[0].data, item => moment(item.time).format('YYYY-MM-DD'));
				// // this.dateRange.forEach(({value}) => {
				// //   let date = moment().dayOfYear(value).format('YYYY-MM-DD');
				// //   values = Object.assign(values, {[date]: observationGroupedByDate[date] ? _.round((this.selectedParameter.property === 'Accumulative' ? _.sum : _.mean)(observationGroupedByDate[date].map(item => item.value)), 2) : ''})
				// // });

				// stations.push({
				//   id: station.id,
				//   name: station.name,
				//   latitude: station.latitude,
				//   longitude: station.longitude,
				//   values
				// });
			}
		});

		// console.log(markers[1597688750000].find(item => item.id == 'station_marker-989'))
		this.p1min = p1min;
		this.p1max = p1max;

		this.p2min = p2min;
		this.p2max = p2max;

		this.arrayMapObj = this.generateArray(p1min, p1max);

		this.timeRange = Object.keys(timeRange).sort((a, b) => +a < +b ? -1 : 1).map((key, index) => ({
			value: index,
			epoch: key,
			date: timeRange[key]
		}));

		if (this.timeRange && this.timeRange[0] && this.timeRange[0].date) {
			// this.stations = stations;
			this.center = getCenter(markers[moment(this.timeRange[0].date).valueOf()])
		}

		this.markers = markers;
		this.isLoading = false;
	}

	getIndexMarker = ({ markers, step, index, selectedMarker }) => {
		let station = markers.find(station => station.station_id === selectedMarker);
		if (!selectedMarker || !station) return null;
		// let value = station.values[this.timeRange[+this.selectedTime].date];
		let value;

		if ((this.selectedParameterName1 > 0 && this.selectedParameterName2 <= 0) || this.hidep2) {
			value = station.value;
		} else {
			value = station.p1Value !== null ? station.p1Value : 0;
		}

		if (value > index && value < index + step) return <span className='fa fa-chevron-left' style={{ marginLeft: '12px' }} />;
		return null;
	};

	@action
	startInterval = (e) => {
		if (e) {
			e.stopPropagation();
			e.preventDefault();
		}

		if (this.selectedTime === this.timeRange[this.timeRange.length - 1].value) {
			this.selectedTime = 0;

			if (this.ref) {
				this.ref.stepDown(this.timeRange.length - 1);
			}
		}

		if (this.interval) {
			this.playing = false;
			clearInterval(this.interval);
			this.interval = null;
		} else {
			this.playing = true;

			this.interval = setInterval(() => {
				if (this.selectedTime === this.timeRange[this.timeRange.length - 1].value) {
					clearInterval(this.interval);
					this.interval = null;
					this.playing = false;
				} else {
					if (this.ref)
						this.ref.stepUp(1);

					this.selectedTime += 1;
				}
			}, this.changeRate);
		}
	}

	@action
	onStationOptionClicked = item => {
		// const station = this.multiStationOptions.find(i => +i.id === +item.id);
		// station.value = !item.value;
		item.value = !item.value;
	}

	@action
	onChangeAllStationOption = (newValue, filterText) => {
		const { stationStore } = this.props;
		const filteredStations = stationStore.filterStations(this.multiStationOptions, filterText.toLowerCase());

		this.multiStationOptions = this.multiStationOptions.map(station => {
			const { value, ...others } = station;

			if (filterText === '' || filteredStations.find(s => +s.id === +station.id))
				return { ...others, value: newValue };

			return { value, ...others };
		});
	};

	// @computed get getAvailableParameters() {
	// 	const { dataSeriesStore, parameterStore } = this.props;
	// 	const availableParameters = [];

	// 	dataSeriesStore.items.forEach(dataSeries => {
	// 		if (this.multiStationOptions.find(station => +station.id === +dataSeries.station_id && station.value)) {
	// 			if (!availableParameters.find(p => +p.id === +dataSeries.parameter_id)) {
	// 				const correspondingParameter = parameterStore.items.find(parameter => +parameter.id === +dataSeries.parameter_id);

	// 				if (correspondingParameter)
	// 					availableParameters.push(correspondingParameter);
	// 			}
	// 		}
	// 	});

	// 	return availableParameters;
	// }

	onSlowDownClick = (e) => {
		if (e) {
			e.stopPropagation();
			e.preventDefault();
		}

		clearTimeout(this.interval);

		this.interval = null;
		this.changeRate += 200;

		this.startInterval();
	}

	onFastForwardClick = (e) => {
		if (e) {
			e.stopPropagation();
			e.preventDefault();
		}

		clearTimeout(this.interval);

		this.interval = null;
		this.changeRate -= 200;

		this.startInterval();
	}

	onStepUpClick = (e) => {
		if (e) {
			e.stopPropagation();
			e.preventDefault();
		}

		if (this.selectedTime !== this.timeRange[this.timeRange.length - 1].value) {
			clearTimeout(this.interval);

			this.interval = null;
			this.playing = false;

			if (this.ref)
				this.ref.stepUp(1);

			this.selectedTime += 1;
		}
	};

	onBackClick = (e) => {
		if (e) {
			e.stopPropagation();
			e.preventDefault();
		}

		if (this.selectedTime !== this.timeRange[0].value) {
			clearTimeout(this.interval);

			this.interval = null;
			this.playing = false;

			if (this.ref)
				this.ref.stepDown(1);

			this.selectedTime -= 1;
		}
	}

	onSkipToLastClick = (e) => {
		if (e) {
			e.stopPropagation();
			e.preventDefault();
		}

		const currentIndex = this.selectedTime;

		if (this.ref)
			this.ref.stepUp(this.timeRange.length - 1 - currentIndex);

		this.selectedTime = this.timeRange[this.timeRange.length - 1].value;
		clearTimeout(this.interval);
		this.interval = null;
		this.playing = false;
	}

	onStepDownClick = (e) => {
		if (e) {
			e.stopPropagation();
			e.preventDefault();
		}

		const currentIndex = this.selectedTime;

		if (this.ref)
			this.ref.stepDown(currentIndex);

		this.selectedTime = this.timeRange[0].value;
		clearTimeout(this.interval);
		this.interval = null;
		this.playing = false;
	};

	render() {
		const { mapStore, parameterStore, stationStore } = this.props;
		const { onMarkerOver, selectedMarker } = mapStore;

		if (stationStore.isLoading || parameterStore.isLoading) return <Spinner />

		const roundOff = num => Math.round(num * 100) / 100;

		let min = this.selectedParameterName1 > 0 ? this.p1min : this.p2min,
			max = this.selectedParameterName1 > 0 ? this.p1max : this.p2max,
			selectedParameter = this.selectedParameterName1 > 0 ? this.selectedParameter1 : this.selectedParameter2,
			{ arrayMap, step } = this.arrayMapObj;

		let markers = (!!Object.keys(this.markers).length ? toJS(this.markers[moment(this.timeRange[+this.selectedTime].date).seconds(0).valueOf()]) : [])
			.map(item => {
				let colorValue;

				if ((this.selectedParameterName1 > 0 && this.selectedParameterName2 <= 0) || (this.hidep2 && this.selectedParameterName1 > 0)) {
					colorValue = item.value;
				} else if (this.selectedParameterName1 > 0) {
					colorValue = item.p1Value;
				} else {
					colorValue = item.value;
				}

				const p2DirectionMarker = `
        <svg viewBox="0 0 30 30" style="margin-left: -10px; margin-top: -10px">
          <defs>
            <marker id="arrow-${item.station_id}" markerWidth="10" markerHeight="10" refX="0" refY="3" orient="auto" markerUnits="strokeWidth">
              <path d="M0,0 L6,3 L0,3 M6,3 L0,6" stroke="${this.getColorMapIndex(colorValue, min, max)}" stroke-width="1" fill-opacity="0"/>
            </marker>
          </defs>
          
        <path d="M0,0 L24,12 L0,24 L8,12 L0,0 M8,12 L24,12" stroke="grey" stroke-width="1" fill="${this.getColorMapIndex(colorValue, min, max)}" fill-opacity="1" transform="rotate(-${item.value} 12 12)"/>
<!--         <line x1="0" y1="10" x2="10" y2="10" stroke="${this.getColorMapIndex(colorValue, min, max)}" stroke-width="2" marker-end="url(#arrow-${item.station_id})" transform="rotate(-${item.value} 10 10)"/>-->
        </svg>

      `

				return Object.assign(item, {
					smallerIcon: this.p2Direction ?
						p2DirectionMarker : `
        <svg height="8" width="8" style="margin-left: -1px; margin-top: -2px;">
          <circle cx="4" cy="4" r="4" stroke="black" stroke-width="0.5px" fill="${this.getColorMapIndex(colorValue, min, max)}"/>
        </svg>
      `,
					icon:
						this.p2Direction ?
							p2DirectionMarker : `
        <svg width="20" height="20" style="margin-left: -3px; margin-top: -5px;">
          <circle cx="10" cy="10" r="10" stroke="white" stroke-width="0.5px" fill="${this.getColorMapIndex(colorValue, min, max)}"/>
          <text text-anchor="middle" x="10" y="12" font-size="10" fill="${item.value > 2 * (this.min + this.max) / 3 ? 'white' : 'black'}">${Math.floor(item.value)}</text>
        </svg>
      `,
					largerIcon: this.p2Direction ?
						p2DirectionMarker : `
        <svg width="30" height="30" style="margin-left: -3px; margin-top: -5px;">
          <circle cx="15" cy="15" r="15" stroke="white" stroke-width="0.5px" fill="${this.getColorMapIndex(colorValue, min, max)}"/>
          <text text-anchor="middle" x="15" y="20" font-size="15" fill="${item.value > 2 * (this.min + this.max) / 3 ? 'white' : 'black'}">${Math.floor(item.value)}</text>
        </svg>
      `,
				})
			});

		return (
			<div>
				<Form>
					<FormBody>
						<div className='inline-grid'>
							<div>
								<FormMultiSelectInput id='station-multi-select' label='Stations'
									options={this.multiStationOptions}
									// optionsChangeAll={this.onChangeAllStationOption}
									optionClicked={this.onStationOptionClicked}
									isLoading={stationStore.isLoading}
									filterOptions={stationStore.filterStations} />
								<SelectInput
									label={'Parameter 1'}
									value={this.selectedParameterName1}
									fields={{ label: 'name', value: 'id' }}
									options={parameterStore.items}
									onChange={this.onChangeParameter1}
									filterOptions={parameterStore.filterParameters}
								/>
								<SelectInput
									label={'Parameter 2'}
									value={this.selectedParameterName2}
									fields={{ label: 'name', value: 'id' }}
									options={parameterStore.items}
									onChange={this.onChangeParameter2}
									filterOptions={parameterStore.filterParameters}
								/>
							</div>
							<div>
								<DateInput
									label={'Date From'}
									value={this.date_from}
									onChange={this.onChangeDateFrom}
								/>
								<DateInput
									label={'Date To'}
									value={this.date_to}
									onChange={this.onChangeDateTo}
								/>
								{this.selectedParameterName2 > 0 && <div className='formInput'>
									<label>Show Parameter as direction</label>
									<input type="checkbox" checked={this.p2Direction} onChange={e => this.p2Direction = e.target.checked} />
								</div>}
							</div>
						</div>
					</FormBody>
					<FormActions>
						<button onClick={this.onView}>View</button>
					</FormActions>
				</Form>
				{this.isLoading && <Spinner />}
				{!!markers.length && <div className='flex flex-column' style={{ marginTop: '20px', width: '90%' }}>
					<div className='flex flex-row'>
						<LeafletMap id='Analysis-Map'
							center={this.center}
							markers={markers}
							wheelPxPerZoomLevel={120}
							zoomDelta={0.5}
							zoomSnap={0.5}
							height='80vh'
							onMarkerClick={this.onMarkerClick}
							onMarkerOver={onMarkerOver}>
							{selectedMarker && markers.find(item => +item.station_id === +selectedMarker) ? <div
								className='map-info-box'>{this.getPopupBox(markers.find(item => +item.station_id === +selectedMarker))}</div> : null}
							<div className={'map-info-box-bottom-center'}>
								{getDisplayDate(this.timeRange[this.selectedTime].date, { format: 'YYYY-MM-DD HH:mm' })}
							</div>
							<div className={'map-info-box-bottom-left'} id={"overlay"}>
								<Form>
									<button onClick={this.onSlowDownClick}>
										<i className={`fa fa-fast-backward white`} data-toggle="tooltip" title="Slow Down" />
									</button>

									<button onClick={this.onStepDownClick}>
										<i className={`fa fa-step-backward white`} data-toggle="tooltip" title="Skip to First"
										/>
									</button>
									<button onClick={this.onBackClick}>
										<i className={`fa fa-caret-left white`} data-toggle="tooltip" title="Back" />
									</button>
									<button onClick={this.startInterval}>
										<i className={`fa fa-${this.playing ? 'pause' : 'play'} white`} data-toggle="tooltip"
											title={this.playing ? "Pause" : "Play"}
										/>
									</button>
									<button onClick={this.onStepUpClick}>
										<i className={`fa fa-caret-right white`} data-toggle="tooltip" title={"Next"} />
									</button>
									<button onClick={this.onSkipToLastClick}>
										<i className={`fa fa-step-forward white`} data-toggle="tooltip" title="Skip to Last" />
									</button>
									<button onClick={this.onFastForwardClick}>
										<i className={`fa fa-fast-forward white`} data-toggle="tooltip" title="Fast Forward" />
									</button>
								</Form>
							</div>
						</LeafletMap>
						<div className='color-gradient-column'>
							{arrayMap.map((item, i) =>
								<div key={`color-gradient-index-${item}-${i}`} className='color-gradient-item'>
									<i style={{
										background: this.getColorMapIndex(item, min, max),
										height: `calc(80vh / ${arrayMap.length})`
									}}
										data-toggle="tooltip" title={roundOff(item)} />
									{this.getIndexMarker({
										markers,
										step,
										index: item,
										selectedMarker: mapStore.selectedMarker
									})}
									{i === 0 && <span>{roundOff(max)} {selectedParameter.parameter_unit_symbol}</span>}
									{i === arrayMap.length - 1 && <span style={{
										height: `calc(50vh / ${arrayMap.length})`,
										marginTop: `calc(calc(80vh / ${arrayMap.length}) - 12px)`
									}}>{roundOff(min)} {selectedParameter.parameter_unit_symbol}</span>}
								</div>
							)}
						</div>
					</div>
					{/*<br/>*/}
					<br />
					<div>
						<StepRangeSlider
							ref={(ref) => this.ref = ref}
							value={this.selectedTime}
							range={this.timeRange}
							onChange={this.onChangeSelectedTime}
							children={null}
						// children={<span style={{marginTop: '10px', width: '50px'}}>{moment().dayOfYear(this.selected_date).format('YYYY-MM-DD')}</span>}
						/>
						{!!this.timeRange[this.selectedTime] && <span style={{
							marginLeft: `calc(${(this.selectedTime / (this.timeRange.length - 1)) * 100}% - (${(this.selectedTime / (this.timeRange.length - 1)) * 126}px))`,
							whiteSpace: 'nowrap',
							transition: '0.1s linear'
						}}>{getDisplayDate(this.timeRange[this.selectedTime].date, { format: 'YYYY-MM-DD HH:mm' })}</span>}
						{/*<div className='flex flex-row space-between'>{this.timeRange.map(item => <span key={`timeline-labe-${item.value}`} style={{ cursor: 'pointer', color: 'gray', fontSize: 14 }} onClick={() => this.onChangeSelectedDate(item.value)}>{this.selectedTime === item.value ? getDisplayDate(item.date, { format: 'YYYY-MM-DD HH:mm' }) : ''}</span>)}</div>*/}
					</div>
				</div>}
			</div>
		);
	}
}

export default AnalysisMap;



// WEBPACK FOOTER //
// ./src/components/Analysis/AnalysisMap2.js